var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExperimentPref(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9641_5646)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9641_5646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H6.08696V6.08696H0V0Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.95652 0H13.0435V6.08696H6.95652V0Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.913 0H20V6.08696H13.913V0Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 6.95652H6.08696V13.0435H0V6.95652Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.95652 6.95652H13.0435V13.0435H6.95652V6.95652Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.913 6.95652H20V13.0435H13.913V6.95652Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 13.913H6.08696V20H0V13.913Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.95652 13.913H13.0435V20H6.95652V13.913Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.913 13.913H20V20H13.913V13.913Z",
    fill: "current"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9641_5646"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9641_5646"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperimentPref);
export default __webpack_public_path__ + "static/media/ExperimentPref.6fe7f3be9cd7af309b191ba7c39ff031.svg";
export { ForwardRef as ReactComponent };